export class GuaranteeStatus {
  getDescricao(status: string) {
    switch(status) {
      case "1": return "Em criação";
      case "2": return "Aguarando Informações";
      case "3": return "Enviada ao CTC";
      case "4": return "Recebido via Digitalizada";
      case "5": return "Aguardando Registro";
      case "6": return "Recebido Original";
      case "7": return "Recebido Original com Pendência";
      case "8": return "Encerrada";
      case "9": return "Garantia Baixada";
      case "10": return "Garantia devolvida ao Cliente";
      case "11": return "Garantia Enviada ao Jurídico";
      case "12": return "Garantia Vencida";
      default: return "N/D";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/guarantee-status.ts